"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Client {
    constructor(id, nombre_comercial, is_distributor, subclients, created_at, updated_at, code) {
        this.id = id;
        this.nombre_comercial = nombre_comercial;
        this.code = code;
        this.is_distributor = is_distributor;
        this.subclients = subclients;
        this.created_at = created_at;
        this.updated_at = updated_at;
    }
    static fromJson(json) {
        return new Client(json.id, json.nombre_comercial, json.is_distributor, json.subclients ? json.subclients.map(Client.fromJson) : null, json.created_at, json.updated_at, json.c_wineseq);
    }
}
exports.default = Client;
